import { Controller } from 'stimulus';

class SmartLearning extends Controller {
  // eslint-disable-next-line class-methods-use-this
  onCourseClick(event) {
    if (event.target.tagName === 'A' || event.target.tagName === 'BUTTON') {
      return true;
    }

    const { currentTarget } = event;
    const firstLink = currentTarget.querySelector('a');

    if (firstLink) {
      window.location = firstLink.href;
      return false;
    }

    return true;
  }
}

SmartLearning.targets = [
  //
];

export default SmartLearning;
